import React from "react"
import PropTypes from "prop-types"
import Image from "gatsby-image"

const Product = ({ imageFluid, sameHeight, name, numCols }) => { 
  let productClasses = `c-product c-product--${numCols}`;
  if (sameHeight) productClasses += " c-product--same-height";

  return (
    <figure className={productClasses}>
      <Image className="c-image c-product__image" alt={name} fluid={imageFluid} loading="eager" />
      <figcaption className="c-product__name">{name}</figcaption>
    </figure>
  )
}

Product.propTypes = {
  sameHeight: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  imageFluid: PropTypes.object.isRequired,
  numCols: PropTypes.number.isRequired
}

export default Product
